import { useParams } from "react-router-dom";
import iframeDashboardSettings from '../constants/dashboardIframeSettings';
import useAppStore from "../store";
import { fsnrlRoles, gmslRoles, nhrlRoles, nicRoles, nmrlRoles, nobrlRoles, nvrlRoles, coeRoles, adminRoles } from "../constants/roles";

function DashIframe() {
  const user = useAppStore((state) => state.user);

  let { id } = useParams();
  if (!iframeDashboardSettings[id]) return <div>Dashboard {"\""}{id}{"\""} does not exist. Check the URL and try again.</div>

  if (id === "fsnrl" && !user?.roles.some(v => fsnrlRoles.includes(v))) return <h1>You are not authorized to view this Dashboard</h1>
  if (id === "nmrl" && !user?.roles.some(v => nmrlRoles.includes(v))) return <h1>You are not authorized to view this Dashboard</h1>
  if (id === "nic" && !user?.roles.some(v => nicRoles.includes(v))) return <h1>You are not authorized to view this Dashboard</h1>
  if (id === "gmsl" && !user?.roles.some(v => gmslRoles.includes(v))) return <h1>You are not authorized to view this Dashboard</h1>
  if (id === "nobrl" && !user?.roles.some(v => nobrlRoles.includes(v))) return <h1>You are not authorized to view this Dashboard</h1>
  if (id === "nhrl" && !user?.roles.some(v => nhrlRoles.includes(v))) return <h1>You are not authorized to view this Dashboard</h1>
  if (id === "nvrl" && !user?.roles.some(v => nvrlRoles.includes(v))) return <h1>You are not authorized to view this Dashboard</h1>
  if (id === "coe" && !user?.roles.some(v => coeRoles.includes(v))) return <h1>You are not authorized to view this Dashboard</h1>
  if (id === "monitoring" && !user?.roles.some(v => adminRoles.includes(v))) return <h1>You are not authorized to view this Dashboard</h1>

  return <iframe
    title={iframeDashboardSettings[id].url}
    src={iframeDashboardSettings[id].url}
    style={{ 
      height: "100%",
      border: "none",
      overflow: "visible",
      overflowClipMargin: "unset",
      // clipPath: "polygon(0 0, 98% 0%, 98% 100%, 0% 100%)"
    }}
    width="100%"
    height="100%"
  ></iframe>
}

export default DashIframe;
